export enum MultiFieldType {
	TEXT,
	TEXTAREA,
	IMAGE
}
